import Vue from "vue";
import Router from "vue-router";
import Datalist from "./components/Datalist.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      name: "404",
      path: "/404",
      component: () => import("./components/layout/NotFound.vue"),
      title: "全国职业技能入库查询系统后台-无此页面",
      meta: {
        requireAuth: false,
        title: "全国职业技能入库查询系统-无此页面"
      }
    },
    {
      path: "/",
      name: "home",
      component: Datalist,
      meta: {
        requireAuth: true,
        title: "全国职业技能入库查询系统后台"
      }
    },
    {
      path: "/login",
      name: "login",
      component: () => import("./views/Login.vue"),
      meta: {
        title: "全国职业技能入库查询系统后台-登录"
      }
    },
    {
      path: "/reguser",
      name: "reguser",
      component: () => import("./components/Users/Reguser.vue"),
      meta: {
        requireAuth: true,
        title: "全国职业技能入库查询系统后台-注册用户"
      }
    },
    {
      path: "/users",
      name: "users",
      component: () => import("./components/Users/Users.vue"),
      meta: {
        requireAuth: true,
        title: "全国职业技能入库查询系统后台-用户列表"
      }
    },
    {
      path: "/datalist",
      name: "datalist",
      component: Datalist,
      meta: {
        requireAuth: true,
        title: "全国职业技能入库查询系统后台-报名列表"
      }
    },
    {
      path: "/editdata",
      name: "editdata",
      component: () => import("./components/Editdata.vue"),
      meta: {
        requireAuth: true,
        title: "全国职业技能入库查询系统后台-修改"
      }
    },
    {
      path: "/adddata",
      name: "adddata",
      component: () => import("./components/Adddata.vue"),
      meta: {
        requireAuth: true,
        title: "全国职业技能入库查询系统后台-新增"
      }
    },
    {
      path: "/printpage",
      name: "printpage",
      component: () => import("./views/Printpage.vue"),
      meta: {
        requireAuth: true,
        title: "全国职业技能入库查询系统-打印"
      }
    },
    {
      path: "*",
      redirect: "/404",
      title: "全国职业技能入库查询系统-无此页面",
      meta: {
        requireAuth: false,
        title: "全国职业技能入库查询系统-无此页面"
      }
    },
    // 前端展示页面
    {
      path: "/zscx",
      name: "zscx",
      component: () => import("./views/Zscx.vue"),
      meta: {
        requireAuth: false,
        title: "全国职业技能入库查询系统-证书查询"
      }
    },
    {
      path: "/userprofile",
      name: "userprofile",
      component: () => import("./views/Userprofile.vue"),
      meta: {
        requireAuth: false,
        title: "全国职业技能入库查询系统-证书详情"
      }
    }
    // {
    //   path: '/zjcx',
    //   name: 'zjcx',
    //   component: () => import('./views/Zjcx.vue'),
    //   meta: {
    //     requireAuth: false,
    //     title: '全国职业技能入库查询系统-专家查询'
    //   }
    // },
    // {
    //   path: '/hzcx',
    //   name: 'hzcx',
    //   component: () => import('./views/Hzcx.vue'),
    //   meta: {
    //     requireAuth: false,
    //     title: '全国职业技能入库查询系统-合作查询'
    //   }
    // },
  ]
});
